<div class="checkout-container">
  <div class="checkout-topbar">
    <div class="topbar-left">
      <h1>
        Issue Items
        <small>Issue paid reservations or walk-in rentals</small>
      </h1>
      <div class="breadcrumb">
        <i class="bi bi-house-door"></i> <span>Item Rental</span> / <span class="current">Check-Out</span>
        <span class="separator">|</span>
        <span class="time"><i class="bi bi-clock"></i> {{ timestamp }}</span>
      </div>
    </div>
    <div class="topbar-right">
      <div class="search-box">
        <i class="bi bi-search"></i>
        <input type="text" placeholder="Filter by item name..." [ngModel]="searchQuery()" (ngModelChange)="searchQuery.set($event)" />
      </div>

      <button class="btn btn-outline btn-sm" type="button" (click)="exportData()">
        <i class="bi bi-download"></i> Export
      </button>
      <button class="btn btn-primary" type="button" (click)="openCheckoutModal()">
        <i class="bi bi-plus-circle"></i> New Check-Out
      </button>
    </div>
  </div>

  <div class="stats-row">
    <div class="stat-card">
      <div class="stat-icon blue">
        <i class="bi bi-box-seam"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Walk-in available</div>
        <div class="stat-value">{{ pageStats().available }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon amber">
        <i class="bi bi-cash-coin"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Paid — ready to issue</div>
        <div class="stat-value">{{ pageStats().awaitingCheckout }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon green">
        <i class="bi bi-box-arrow-right"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Ready to Process</div>
        <div class="stat-value">{{ pageStats().readyTotal }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon purple">
        <i class="bi bi-box-arrow-up-right"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Currently checked out</div>
        <div class="stat-value">{{ pageStats().checkedOut }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon red">
        <i class="bi bi-exclamation-circle"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Overdue</div>
        <div class="stat-value">{{ pageStats().overdue }}</div>
      </div>
    </div>
  </div>

  @if (paidReservations().length) {
    <div class="completed-reservations-panel">
      <div class="panel-header">
        <h2>
          <i class="bi bi-cash-coin"></i>
          Paid reservations — issue items
        </h2>
        <span class="panel-count">{{ readyReservationsCount() }} waiting</span>
      </div>
      <div class="table-scroll">
        <table class="reservation-queue-table">
          <thead>
            <tr>
              <th>Reservation</th>
              <th>Status</th>
              <th>Customer</th>
              <th>Item</th>
              <th>Branch</th>
              <th>Due</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            @for (reservation of paidReservations(); track reservation.id) {
              <tr [class.checked-out-row]="reservationIssueState(reservation) === 'checked-out'">
                <td>{{ reservation.reservationNumber }}</td>
                <td>
                  @if (reservationIssueState(reservation) === 'checked-out') {
                    Issued out
                  } @else {
                    {{ reservationStatusLabel(reservation.status) }}
                  }
                </td>
                <td>{{ reservation.customer }}</td>
                <td>
                  {{ reservation.equipment }}
                  @if (reservation.quantity > 1) {
                    <span class="item-qty">× {{ reservation.quantity }}</span>
                  }
                </td>
                <td>{{ reservation.branch || '—' }}</td>
                <td>{{ formatDate(reservation.endDate) }}</td>
                <td>
                  @switch (reservationIssueState(reservation)) {
                    @case ('checked-out') {
                      <button type="button" class="btn btn-outline btn-sm" disabled>
                        <i class="bi bi-check-circle"></i>
                        Issued out
                      </button>
                    }
                    @case ('issuing') {
                      <button type="button" class="btn btn-primary btn-sm" disabled>
                        <i class="bi bi-hourglass-split"></i>
                        Issuing...
                      </button>
                    }
                    @default {
                      <button
                        type="button"
                        class="btn btn-primary btn-sm"
                        [disabled]="checkoutSubmitting() || reservationIssueState(reservation) !== 'ready'"
                        (click)="releaseFromReservation(reservation)"
                      >
                        <i class="bi bi-box-arrow-right"></i>
                        Issue item
                      </button>
                    }
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }

  @if (activeCheckedOutCheckouts().length) {
    <div class="checked-out-panel">
      <div class="panel-header">
        <h2>
          <i class="bi bi-box-arrow-up-right"></i>
          Currently checked out
        </h2>
        <span class="panel-count">{{ activeCheckedOutCheckouts().length }} out</span>
      </div>
      <div class="panel-toolbar">
        <div class="search-box compact">
          <i class="bi bi-search"></i>
          <input
            type="text"
            placeholder="Filter by item name..."
            [ngModel]="checkedOutSearchQuery()"
            (ngModelChange)="checkedOutSearchQuery.set($event)"
          />
        </div>
      </div>
      <div class="table-scroll">
        <table class="reservation-queue-table checked-out-table">
          <thead>
            <tr>
              <th>Checkout</th>
              <th>Item</th>
              <th>Qty out</th>
              <th>Returned</th>
              <th>Outstanding</th>
              <th>Customer</th>
              <th>Destination</th>
              <th>Branch</th>
              <th>Checked out</th>
              <th>Due</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            @for (checkout of activeCheckedOutCheckouts(); track checkout.id) {
              <tr
                class="clickable-row"
                [class.overdue-row]="isOverdue(checkout)"
                (click)="openCheckoutDetail(checkout)"
              >
                <td>{{ checkout.checkoutNumber }}</td>
                <td>
                  <div class="item-info-inline">
                    <span class="item-icon"><i class="bi" [class]="findAssetIcon(checkout)"></i></span>
                    <div>
                      <div class="item-name">{{ checkout.equipment }}</div>
                      <div class="item-id">{{ checkout.assetNumber || '—' }}</div>
                    </div>
                  </div>
                </td>
                <td>{{ checkout.quantity ?? 1 }}</td>
                <td>{{ checkout.quantityReturned ?? 0 }}</td>
                <td>{{ checkout.quantityOutstanding ?? checkout.quantity ?? 1 }}</td>
                <td>{{ checkout.customer }}</td>
                <td>{{ checkout.destination || '—' }}</td>
                <td>{{ checkout.branch || '—' }}</td>
                <td>{{ formatDate(checkout.checkoutDate) }}</td>
                <td>
                  <span>{{ formatDate(checkout.dueDate) }}</span>
                  <span class="days-chip" [class]="daysLeftLabel(checkout).className">
                    {{ daysLeftLabel(checkout).label }}
                  </span>
                </td>
                <td>
                  <span
                    class="status-chip"
                    [class.overdue]="isOverdue(checkout)"
                    [class.active]="!isOverdue(checkout)"
                  >
                    {{ checkoutStatusLabel(isOverdue(checkout) ? 'overdue' : checkout.status) }}
                  </span>
                </td>
                <td class="actions-cell" (click)="$event.stopPropagation()">
                  <button
                    type="button"
                    class="btn btn-outline btn-sm"
                    title="View details"
                    (click)="openCheckoutDetail(checkout)"
                  >
                    <i class="bi bi-eye"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-success btn-sm"
                    title="Check in"
                    (click)="goToCheckIn(checkout)"
                  >
                    <i class="bi bi-arrow-return-left"></i>
                  </button>
                  @if (isOverdue(checkout)) {
                    <button
                      type="button"
                      class="btn btn-danger btn-sm"
                      title="Open overdue item on Check-In"
                      (click)="goToCheckIn(checkout, true)"
                    >
                      <i class="bi bi-exclamation-triangle"></i>
                      Overdue
                    </button>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }

  <div class="filter-bar">
    <div class="filter-left">
      <div class="filter-group">
        <label><i class="bi bi-tags"></i> Category</label>
        <select [ngModel]="categoryFilter()" (ngModelChange)="categoryFilter.set($event)">
          <option value="">All Categories</option>
          @for (category of categories(); track category) {
            <option [value]="category">{{ category }}</option>
          }
        </select>
      </div>
      <div class="filter-group">
        <label><i class="bi bi-geo-alt"></i> Location</label>
        <select [ngModel]="locationFilter()" (ngModelChange)="locationFilter.set($event)">
          <option value="">All Locations</option>
          @for (location of locations(); track location) {
            <option [value]="location">{{ location }}</option>
          }
        </select>
      </div>
    </div>
    <div class="filter-right">
      <span class="filter-count">Showing {{ filteredAssets().length }} walk-in items</span>
    </div>
  </div>

  <div class="available-panel">
    <div class="panel-header">
      <h2>
        <i class="bi bi-box-seam"></i>
        Walk-in available — free stock (not reserved)
      </h2>
      <span class="panel-count available">{{ filteredAssets().length }} available</span>
    </div>
    <div class="table-scroll">
        <table class="reservation-queue-table available-table">
          <thead>
            <tr>
              <th>Item</th>
              <th>Item ID</th>
              <th>Category</th>
              <th>Location</th>
              <th>Free at branch</th>
              <th>Condition</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            @for (asset of filteredAssets(); track asset.id) {
              <tr>
                <td>
                  <div class="item-info-inline">
                    <span class="item-icon"><i class="bi" [class]="asset.icon ?? 'bi-box-seam'"></i></span>
                    <div>
                      <div class="item-name">{{ asset.name }}</div>
                      @if (asset.serialNumber) {
                        <div class="item-id">{{ asset.serialNumber }}</div>
                      }
                    </div>
                  </div>
                </td>
                <td>{{ asset.assetId }}</td>
                <td>{{ asset.category }}</td>
                <td>{{ asset.location }}</td>
                <td>
                  <span class="qty-pill" title="Free stock at branch (on hand − reserved). Pick a store location at check-out for exact qty.">
                    {{ availableQuantityForAsset(asset) }}
                  </span>
                </td>
                <td>{{ conditionLabel(asset.condition) }}</td>
                <td>
                  <span class="status-chip active">Available</span>
                </td>
                <td class="actions-cell">
                  <button type="button" class="btn btn-primary btn-sm" (click)="openCheckoutModal(asset)">
                    <i class="bi bi-box-arrow-right"></i>
                    Check Out
                  </button>
                </td>
              </tr>
            } @empty {
              <tr>
                <td colspan="8" class="empty-row">No walk-in items available for checkout.</td>
              </tr>
            }
          </tbody>
        </table>
    </div>
  </div>

  <div class="pagination-bar">
    <div class="pagination-info">
      Showing <span>1</span> to <span>{{ filteredAssets().length }}</span> of <span>{{ filteredAssets().length }}</span> walk-in items
    </div>
  </div>
</div>

<div class="modal-overlay" [class.open]="showDetailModal()" (click)="closeModalOnBackdrop($event)">
  <div class="modal modal-large">
    <div class="modal-header">
      <h2><i class="bi bi-box-arrow-up-right"></i> Checkout Details</h2>
      <button class="close-btn" (click)="closeDetailModal()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    @if (selectedCheckout(); as checkout) {
      <div class="modal-body">
        @if (isOverdue(checkout)) {
          <div class="detail-alert overdue">
            <i class="bi bi-exclamation-triangle-fill"></i>
            <div>
              <strong>Overdue by {{ daysOverdue(checkout) }} day(s)</strong>
              <span> — process check-in when the item is returned.</span>
            </div>
          </div>
        }

        <div class="detail-grid">
          <div class="detail-block">
            <label>Checkout No.</label>
            <div>{{ checkout.checkoutNumber }}</div>
          </div>
          <div class="detail-block">
            <label>Status</label>
            <div>
              <span
                class="status-chip"
                [class.overdue]="isOverdue(checkout)"
                [class.active]="!isOverdue(checkout)"
              >
                {{ checkoutStatusLabel(isOverdue(checkout) ? 'overdue' : checkout.status) }}
              </span>
            </div>
          </div>
          <div class="detail-block">
            <label>Item</label>
            <div>{{ checkout.equipment }}</div>
          </div>
          <div class="detail-block">
            <label>Quantity out</label>
            <div>{{ checkout.quantity ?? 1 }}</div>
          </div>
          <div class="detail-block">
            <label>Returned</label>
            <div>{{ checkout.quantityReturned ?? 0 }}</div>
          </div>
          <div class="detail-block">
            <label>Outstanding</label>
            <div>{{ checkout.quantityOutstanding ?? checkout.quantity ?? 1 }}</div>
          </div>
          <div class="detail-block">
            <label>Item / Tag</label>
            <div>{{ checkout.assetNumber || selectedAsset()?.assetId || '—' }}</div>
          </div>
          <div class="detail-block">
            <label>Serial Number</label>
            <div>{{ checkout.serialNumber || selectedAsset()?.serialNumber || '—' }}</div>
          </div>
          <div class="detail-block">
            <label>Category</label>
            <div>{{ checkout.category || selectedAsset()?.category || '—' }}</div>
          </div>
          <div class="detail-block">
            <label>Customer</label>
            <div>{{ checkout.customer }}</div>
          </div>
          <div class="detail-block">
            <label>Contact Phone</label>
            <div>{{ checkout.receiverPhone || '—' }}</div>
          </div>
          <div class="detail-block">
            <label>Destination</label>
            <div>{{ checkout.destination || '—' }}</div>
          </div>
          <div class="detail-block">
            <label>Vehicle Registration</label>
            <div>{{ checkout.vehicleRegistration || '—' }}</div>
          </div>
          <div class="detail-block">
            <label>Branch</label>
            <div>{{ checkout.branch || '—' }}</div>
          </div>
          <div class="detail-block">
            <label>Location</label>
            <div>{{ checkout.location || selectedAsset()?.location || '—' }}</div>
          </div>
          <div class="detail-block">
            <label>Reservation</label>
            <div>{{ checkout.reservationNumber || '—' }}</div>
          </div>
          <div class="detail-block">
            <label>Case Number</label>
            <div>{{ checkout.caseNumber || '—' }}</div>
          </div>
          <div class="detail-block">
            <label>Checked Out</label>
            <div>{{ formatDate(checkout.checkoutDate) }}</div>
          </div>
          <div class="detail-block">
            <label>Due Date</label>
            <div>{{ formatDate(checkout.dueDate) }}</div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn btn-outline" (click)="closeDetailModal()">Close</button>
        <button class="btn btn-success" (click)="goToCheckIn(checkout)">
          <i class="bi bi-arrow-return-left"></i> Check In
        </button>
        @if (isOverdue(checkout)) {
          <button class="btn btn-danger" (click)="goToCheckIn(checkout, true)">
            <i class="bi bi-exclamation-triangle"></i> View Overdue on Check-In
          </button>
        }
      </div>
    }
  </div>
</div>

<div class="modal-overlay" [class.open]="showCheckoutModal()" (click)="closeModalOnBackdrop($event)">
  <div class="modal modal-large">
    <div class="modal-header">
      <h2><i class="bi bi-box-arrow-right"></i> Issue Items</h2>
      <button class="close-btn" (click)="closeCheckoutModal()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="modal-body">
      <div class="form-row">
        <div class="form-group">
          <label>Item <span class="required">*</span></label>
          <select
            [ngModel]="selectedAsset()?.id ?? ''"
            (ngModelChange)="onAssetSelect($event)"
            [disabled]="!!activeReservationId()"
          >
            <option value="">Select item...</option>
            @for (asset of modalAssets(); track asset.id) {
              <option [value]="asset.id" [disabled]="isCheckoutDisabled(asset.status)">
                {{ asset.name }} ({{ asset.assetId }})
              </option>
            }
          </select>
        </div>
        <div class="form-group">
          <label>Item Name</label>
          <input type="text" [value]="selectedAsset()?.name ?? ''" disabled />
          @if (issuingGroupCount() > 1) {
            <small class="field-hint">
              This reservation has {{ issuingGroupCount() }} units for this customer. Issuing will release all of them.
            </small>
          }
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label>Customer / Case @if (!activeReservationId()) { <span class="required">*</span> }</label>
          @if (activeReservationId()) {
            <input type="text" [value]="checkoutCustomer()" readonly />
          } @else {
            <input type="text" placeholder="Enter customer, job, or case name..." [ngModel]="checkoutCustomer()" (ngModelChange)="checkoutCustomer.set($event)" />
          }
        </div>
        <div class="form-group">
          <label>Contact Phone <span class="required">*</span></label>
          <input type="tel" placeholder="Customer phone number..." appPhoneOnly [ngModel]="checkoutCustomerPhone()" (ngModelChange)="checkoutCustomerPhone.set($event)" />
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label>Expected Return Date <span class="required">*</span></label>
          <input type="date" [ngModel]="checkoutDueDate()" (ngModelChange)="checkoutDueDate.set($event)" />
        </div>
        @if (isWalkInQuantityCheckout()) {
          <div class="form-group">
            <label>Store Location <span class="required">*</span></label>
            <select
              [ngModel]="checkoutStoreLocationId()"
              (ngModelChange)="onCheckoutStoreLocationChange($event)"
            >
              <option value="">Select location with stock...</option>
              @for (location of walkInStockLocations(); track location.id) {
                <option [value]="location.id">
                  {{ location.name }} ({{ location.available }} available)
                </option>
              }
            </select>
            @if (!walkInStockLocations().length) {
              <small class="field-hint">No store location has free stock for this item.</small>
            } @else if (!checkoutStoreLocationId()) {
              <small class="field-hint">Pick where to take the stock from before entering quantity.</small>
            }
          </div>
        }
      </div>

      @if (isWalkInQuantityCheckout()) {
        <div class="form-row">
          <div class="form-group">
            <label>Quantity <span class="required">*</span></label>
            <div class="qty-with-available">
              <div class="available-qty-box" [class.zero]="walkInAvailableQuantity() <= 0">
                <span class="available-qty-label">Available Qty</span>
                <span class="available-qty-value">{{ walkInAvailableQuantity() }}</span>
              </div>
              <input
                type="number"
                min="1"
                step="1"
                appDigitsOnly
                [max]="walkInAvailableQuantity() || 1"
                [ngModel]="checkoutQuantity()"
                (ngModelChange)="onCheckoutQuantityChange($event)"
                [disabled]="!checkoutStoreLocationId()"
              />
            </div>
            @if (walkInQuantityHint()) {
              <small class="field-hint">{{ walkInQuantityHint() }}</small>
            }
          </div>
        </div>
      }

      <div class="form-row">
        <div class="form-group">
          <label>Destination <span class="required">*</span></label>
          <input
            type="text"
            placeholder="Where is this going? (job site, venue, address…)"
            [ngModel]="checkoutDestination()"
            (ngModelChange)="checkoutDestination.set($event)"
          />
        </div>
        <div class="form-group">
          <label>Vehicle / Reg (optional)</label>
          <input
            type="text"
            placeholder="Vehicle registration if applicable"
            [ngModel]="checkoutVehicle()"
            (ngModelChange)="checkoutVehicle.set($event)"
          />
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn btn-outline" (click)="closeCheckoutModal()">Cancel</button>
      <button class="btn btn-primary" [disabled]="checkoutSubmitting()" (click)="confirmCheckout()">
        <i class="bi bi-check-lg"></i>
        {{ checkoutSubmitting() ? 'Processing...' : 'Confirm Check-Out' }}
      </button>
    </div>
  </div>
</div>

<div class="modal-overlay" [class.open]="showEditModal()" (click)="closeModalOnBackdrop($event)">
  <div class="modal">
    <div class="modal-header">
      <h2><i class="bi bi-pencil"></i> Edit Item</h2>
      <button class="close-btn" (click)="closeEditModal()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="modal-body">
      <div class="form-row">
        <div class="form-group">
          <label>Name <span class="required">*</span></label>
          <input type="text" [ngModel]="editName()" (ngModelChange)="editName.set($event)" />
        </div>
        <div class="form-group">
          <label>Location <span class="required">*</span></label>
          <input type="text" [ngModel]="editLocation()" (ngModelChange)="editLocation.set($event)" />
        </div>
      </div>
      <div class="form-row">
        <div class="form-group">
          <label>Condition <span class="required">*</span></label>
          <select [ngModel]="editCondition()" (ngModelChange)="editCondition.set($event)">
            <option value="good">Good</option>
            <option value="fair">Fair</option>
            <option value="poor">Poor</option>
          </select>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn btn-outline" (click)="closeEditModal()">Cancel</button>
      <button class="btn btn-primary" (click)="saveAsset()">
        <i class="bi bi-check-lg"></i> Save Changes
      </button>
    </div>
  </div>
</div>

<div class="toast-container" [class.show]="showToast()">
  <div
    class="toast"
    [class.success]="toastType() === 'success'"
    [class.error]="toastType() === 'error'"
    [class.info]="toastType() === 'info'"
  >
    <div class="toast-icon">
      @if (toastType() === 'error') {
        <i class="bi bi-x-circle-fill"></i>
      } @else if (toastType() === 'info') {
        <i class="bi bi-info-circle-fill"></i>
      } @else {
        <i class="bi bi-check-circle-fill"></i>
      }
    </div>
    <div class="toast-content">
      <div class="toast-title">
        {{ toastType() === 'error' ? 'Error' : toastType() === 'info' ? 'Notice' : 'Success!' }}
      </div>
      <div class="toast-message">{{ toastMessage() }}</div>
    </div>
    <button class="toast-close" (click)="closeToast()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>
</div>
